import axios from "axios";
import { Utilitarios } from "../../../utils";
import { formatarData } from "../../../utils/datas";
import { ToastErro } from "../../../utils/utilitarios";
import { toast } from "react-toastify";

// Indices das colunas do cashback
export const cashbackIndexTable = {
  status: 0,
  id: 1,
  store: 2,
  cvSale: 3,
  nameClient: 4,
  cellPhone: 5,
  valueSale: 6,
  valueVoucher: 7,
  dateSend: 8,
  datePraz: 9,
};

export const convertItemToObject = (item) => {
  return {
    id: item[cashbackIndexTable.id],
    store: item[cashbackIndexTable.store],
    cvSale: item[cashbackIndexTable.cvSale],
    nameClient: item[cashbackIndexTable.nameClient],
    cellPhone: item[cashbackIndexTable.cellPhone],
    valueSale: Utilitarios.converter(item[cashbackIndexTable.valueSale]),
    valueVoucher: Utilitarios.converter(item[cashbackIndexTable.valueVoucher]),
    dateSend: formatarData(item[cashbackIndexTable.dateSend]),
    datePraz: formatarData(item[cashbackIndexTable.datePraz]),
    status: item[cashbackIndexTable.status],
  };
};

export const getStatusCashback = (status) => {
  switch (status) {
    case "C":
      return "FiberNew";
    case "U":
      return "ThumbUp";
    case "V":
      return "ThumbDown";
    case "E":
      return "Send";
    default:
      return "Help";
  }
};

export const getLabelStatusCashback = (status) => {
  switch (status) {
    case "C":
      return "Criado";
    case "U":
      return "Utilizado";
    case "V":
      return "Vencido";
    case "E":
      return "Enviado";
    default:
      return "Desconhecido";
  }
};

export const getTitleStatusCashback = (status) => {
  switch (status) {
    case "C":
      return "Voucher criado, ainda não enviado ao cliente.";
    case "U":
      return "Voucher utilizado pelo cliente.";
    case "V":
      return "Voucher passou do prazo para utilização";
    case "E":
      return "Voucher enviado ao cliente.";
    default:
      return "Desconhecido";
  }
};

export const getColorStatusCashback = (status) => {
  switch (status) {
    case "C":
      return "info";
    case "U":
      return "success";
    case "V":
      return "error";
    case "E":
      return "warning";
    default:
      return "default";
  }
};

export const sendMessageWhatsApp = async (id, cellPhone) => {
  try {
    const response = await axios.post("/cashback_api/enviar_mensagem", { id });
    toast.dark(response.data.sucesso, { type: "success" });
    // (function () {
    //   if (
    //     /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    //       navigator.userAgent
    //     )
    //   ) {
    //     window.open(
    //       `https://api.whatsapp.com/send?phone=55${cellPhone}&text=${response.data.mensagem}`,
    //       "_blank"
    //     );
    //   } else {
    //     window.open(
    //       `https://web.whatsapp.com/send?phone=55${cellPhone}&text=${response.data.mensagem}`,
    //       "_blank"
    //     );
    //   }
    // })();
  } catch (error) {
    ToastErro("Erro ao buscar mensagem para WhatsApp");
  }
};
